import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'

const annotatedSentimentResolver: FieldResolver = (metadata: Metadata) =>
  ({ annotatedSentiment: metadata.getAnnotatedSentiment() } as StreamData)

export default annotatedSentimentResolver
